export const BrokerStatus = {
  Pending: { id: 'APPROVAL_PENDING', name: 'Approval Pending' },
  Approved: { id: 'APPROVED', name: 'Approved' },
  Suspended: { id: 'SUSPENDED', name: 'Suspended' },
  Disqualified: { id: 'DISQUALIFIED', name: 'Disqualified' },
  Invalid: { id: 'INVALID', name: 'Invalid' },
  DNU: { id: 'DNU', name: 'DNU — VC only' },
  Limited: { id: 'LIMITED', name: 'Limited' },
}

export const BROKER_STATUS_CHOICES = Object.values(BrokerStatus)

export const BrokerStatusTransitions = {
  [BrokerStatus.Pending.id]: [
    BrokerStatus.Pending,
    BrokerStatus.Approved,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.Limited,
  ],
  [BrokerStatus.Approved.id]: [
    BrokerStatus.Approved,
    BrokerStatus.Suspended,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.DNU,
    BrokerStatus.Limited,
  ],
  [BrokerStatus.Suspended.id]: [
    BrokerStatus.Approved,
    BrokerStatus.Suspended,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.Limited,
  ],
  [BrokerStatus.Disqualified.id]: [
    BrokerStatus.Approved,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.Limited,
  ],
  [BrokerStatus.Invalid.id]: [BrokerStatus.Pending, BrokerStatus.Invalid, BrokerStatus.Limited],
  [BrokerStatus.DNU.id]: [
    BrokerStatus.Approved,
    BrokerStatus.Suspended,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.DNU,
    BrokerStatus.Limited,
  ],
  [BrokerStatus.Limited.id]: [
    BrokerStatus.Approved,
    BrokerStatus.Suspended,
    BrokerStatus.Disqualified,
    BrokerStatus.Invalid,
    BrokerStatus.DNU,
    BrokerStatus.Limited,
  ],
}

export const REASONS_REQUIRED_BROKER_STATUSES = [
  BrokerStatus.Suspended.id,
  BrokerStatus.Disqualified.id,
  BrokerStatus.Invalid.id,
  BrokerStatus.Limited.id,
  BrokerStatus.DNU.id,
]

export const getBrokerTransitionProps = (status: string) => {
  if (!Object.keys(BrokerStatusTransitions).includes(status)) {
    return undefined
  }

  return BrokerStatusTransitions[status]
}
